import { useAuthContext } from '@/auth/useAuthContext';

export const usePendingRegistration = () => {
  const { user } = useAuthContext();

  const { companyStatus } = user || {};

  return {
    isPendingRegistration: companyStatus === 'pending',
  };
};
